import { keyValueMirror } from 'store/storeFunctions';

export const actions = keyValueMirror(
  'SET_THEME',
  'ADD_MESSAGE',
  'REMOVE_MESSAGE',
  'CLEAR_MESSAGES',
  'CLIENT_AUTHORIZED',
  'SET_CLIENT_AUTHORIZED',
  'SET_CHECKING_AUTHORIZED',
);

export const setTheme = theme => ({
  type: actions.SET_THEME,
  payload: theme,
});

export const addMessage = (messages, clearExisting) => {
  return {
    type: actions.ADD_MESSAGE,
    payload: [ ...messages ],
    meta: { clearExisting },
  };
};

export const removeMessage = index => {
  return {
    type: actions.REMOVE_MESSAGE,
    payload: index,
  };
};

export const clearMessages = () => ({
  type: actions.CLEAR_MESSAGES,
});

export const isClientAuthorized = args => async dispatch => {
  const { token, callback } = args;

  try {
    dispatch(setCheckingAuthorized(true));
    const appId = btoa('viewer.archvision.app');
    const url = `https://apiprod.archvision.services/clients/auth/authorized?applicationId=${appId}`;

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await fetch(url, options);

    if (res.status === 404) {
      dispatch(setClientAuthorized(false));
      return;
    }

    if (!res.ok) {
      dispatch(setClientAuthorized(false));
      return;
    }

    dispatch(setClientAuthorized(true));
    return;

  } catch (error) {
    console.error(error);
    return;
  } finally {
    dispatch(setCheckingAuthorized(false));
    callback?.();
  }
};

export const setClientAuthorized = payload => ({
  type: actions.SET_CLIENT_AUTHORIZED,
  payload,
});

export const setCheckingAuthorized = payload => ({
  type: actions.SET_CHECKING_AUTHORIZED,
  payload,
});